import PropTypes from 'prop-types';

import styles from './PageTitle.styles.scss';

const PageTitle = ({ children, icon: Icon }) => {
  return (
    <div className={styles.titleContainer}>
      {Icon && <Icon className={styles.titleIcon} />}
      <h1 className={styles.title}>{children}</h1>
    </div>
  );
};

export default PageTitle;

PageTitle.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.any
};
